var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"justify-center"},[_c('v-card',{staticClass:"ma-5",attrs:{"width":"900"}},[_c('v-card-text',[_c('terms-statement')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }